import { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import { AuthProvider, RequireAuth } from "./lib/auth";
import Home from "./pages/Home";
import Login from "./pages/Login";

// Lazy-load heavy chunks so the public embed bundle stays small.
const Embed = lazy(() => import("./pages/Embed"));
const AssemblyViewer = lazy(() => import("./pages/AssemblyViewer"));
const AdminLayout = lazy(() => import("./pages/admin/Layout"));
const AdminModels = lazy(() => import("./pages/admin/Models"));
const AdminModelEditor = lazy(() => import("./pages/admin/ModelEditor"));
const AdminAssemblies = lazy(() => import("./pages/admin/Assemblies"));
const AdminAssemblyEditor = lazy(() => import("./pages/admin/AssemblyEditor"));

function Loading() {
  return <div className="flex h-screen items-center justify-center text-slate-500">Loading…</div>;
}

export default function App() {
  return (
    <AuthProvider>
      <Suspense fallback={<Loading />}>
        <Routes>
          {/* The entire platform is password-locked: only /login is public. */}
          <Route
            path="/"
            element={
              <RequireAuth>
                <Home />
              </RequireAuth>
            }
          />
          <Route path="/login" element={<Login />} />
          <Route
            path="/embed/:id"
            element={
              <RequireAuth>
                <Embed />
              </RequireAuth>
            }
          />
          <Route
            path="/assembly/:id"
            element={
              <RequireAuth>
                <AssemblyViewer />
              </RequireAuth>
            }
          />
          <Route
            path="/admin"
            element={
              <RequireAuth admin>
                <AdminLayout />
              </RequireAuth>
            }
          >
            <Route index element={<AdminModels />} />
            <Route path="models/:id" element={<AdminModelEditor />} />
            <Route path="assemblies" element={<AdminAssemblies />} />
            <Route path="assemblies/:id" element={<AdminAssemblyEditor />} />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </AuthProvider>
  );
}

function NotFound() {
  return (
    <div className="flex h-screen flex-col items-center justify-center gap-2 text-slate-500">
      <div className="text-4xl font-semibold text-slate-800">404</div>
      <div>That page doesn't exist.</div>
      <a href="/" className="text-brand-600 hover:underline">
        Back home
      </a>
    </div>
  );
}
